import request from "../request";

export const getElementsStructure = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/element-structure`).then((res) => res);

export const updateBasicInformationElementStructure = (curriculumId, data) =>
  request.put(`curriculum/${curriculumId}/element-structure/basic-information`, data).then((res) => res);

export const updateChildrenElementStructure = (curriculumId, data) =>
  request.put(`curriculum/${curriculumId}/element-structure/children`, data).then((res) => res);

export const updateTypeChildrenElementStructure = (curriculumId, type, data) =>
  request.put(`curriculum/${curriculumId}/element-structure/children/${type}`, data).then((res) => res);

